import React from "react";
import { Grid, Paper } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DebouncedTextField } from "../DebouncedTextView";

interface DateFiltersProps {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  coursePrefix: string;
  onStartDateChange: (date: dayjs.Dayjs) => void;
  onEndDateChange: (date: dayjs.Dayjs) => void;
  onCoursePrefixChange: (prefix: string) => void;
}

export function DateFilters({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onCoursePrefixChange,
}: DateFiltersProps) {
  return (
    <Paper sx={{ p: 3, mb: 4 }}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => newValue && onStartDateChange(newValue)}
              maxDate={endDate}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) => newValue && onEndDateChange(newValue)}
              minDate={startDate}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <DebouncedTextField
            fullWidth
            label="Course Name"
            onTextChange={(value) => onCoursePrefixChange(value)}
            placeholder="Filter by course name..."
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
